// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1wwme","content":"RecentSearches_content__2t-Ww"};